'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Util


// Components


// Action Creators


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _stringUtil = require('../../../../../common/utils/stringUtil');

var _BoardPopupListItem = require('../../../../components/popupPanel/types/listItems/BoardPopupListItem');

var _BoardPopupListItem2 = _interopRequireDefault(_BoardPopupListItem);

var _navigationActions = require('../../../../reducers/navigationActions');

require('./LiveEditingEntry.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        dispatchNavigateToLinkedBoard: function dispatchNavigateToLinkedBoard(boardId) {
            return dispatch((0, _navigationActions.navigateToBoard)({ boardId: boardId }));
        }
    };
};

var liveEditingEntrySelectorCreator = function liveEditingEntrySelectorCreator() {
    return (0, _reselect.createSelector)(function (state, ownProps) {
        return state.getIn(['elements', ownProps.boardId]);
    }, function (state, ownProps) {
        return state.get('users').filter(function (user) {
            return ownProps.users.indexOf(user.get('_id')) !== -1;
        });
    }, function (activeBoard, activeUsers) {
        return {
            activeBoard: activeBoard,
            activeUsers: activeUsers
        };
    });
};

var TimestampComponent = function TimestampComponent() {
    return null;
};

var describeUsers = function describeUsers(users) {
    return users.valueSeq().reduce(function (sentence, user, index, self) {
        var separator = (0, _stringUtil.listSeparator)(index, self.size);
        return '' + sentence + user.getIn(['name', 'displayName']) + separator;
    }, '');
};

var ActivityComponent = function ActivityComponent(_ref) {
    var users = _ref.users;
    return _react2.default.createElement(
        'span',
        null,
        describeUsers(users),
        ' ',
        (0, _stringUtil.chooseSingular)(users.size, 'is', 'are'),
        ' viewing'
    );
};

ActivityComponent.propTypes = {
    users: _propTypes2.default.object.isRequired
};

var LiveEditingEntry = (_dec = (0, _reactRedux.connect)(liveEditingEntrySelectorCreator, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(LiveEditingEntry, _React$Component);

    function LiveEditingEntry(props) {
        _classCallCheck(this, LiveEditingEntry);

        var _this = _possibleConstructorReturn(this, (LiveEditingEntry.__proto__ || Object.getPrototypeOf(LiveEditingEntry)).call(this, props));

        _this.navigateToLinkedBoard = _this.navigateToLinkedBoard.bind(_this);
        return _this;
    }

    _createClass(LiveEditingEntry, [{
        key: 'navigateToLinkedBoard',
        value: function navigateToLinkedBoard(event) {
            event.preventDefault();
            var _props = this.props,
                dispatchNavigateToLinkedBoard = _props.dispatchNavigateToLinkedBoard,
                boardId = _props.boardId;


            dispatchNavigateToLinkedBoard(boardId);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                activeBoard = _props2.activeBoard,
                activeUsers = _props2.activeUsers;


            return _react2.default.createElement(_BoardPopupListItem2.default, {
                className: 'LiveEditingEntry',
                board: activeBoard,
                users: activeUsers,
                active: true,
                navigateToLinkedBoard: this.navigateToLinkedBoard,
                TimestampComponent: TimestampComponent,
                ActivityComponent: ActivityComponent });
        }
    }]);

    return LiveEditingEntry;
}(_react2.default.Component)) || _class);


LiveEditingEntry.propTypes = {
    boardId: _propTypes2.default.string.isRequired,
    activeBoard: _propTypes2.default.object,
    activeUsers: _propTypes2.default.object,
    dispatchNavigateToLinkedBoard: _propTypes2.default.func
};

exports.default = LiveEditingEntry;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/liveEditing/LiveEditingEntry.js
// module id = 2183
// module chunks = 0